import { Mail, Phone, MessageSquare, MessageCircle, Instagram, Video, Globe } from 'lucide-react';
import { clsx } from 'clsx';

interface Props {
  channel: string;
  size?: 'sm' | 'md';
  className?: string;
}

export function ChannelIcon({ channel, size = 'sm', className }: Props) {
  const iconClass = clsx(
    {
      'h-3.5 w-3.5': size === 'sm',
      'h-5 w-5': size === 'md',
    },
    className,
  );

  switch (channel) {
    case 'email':
      return <Mail className={clsx(iconClass, 'text-blue-400')} />;
    case 'voice':
      return <Phone className={clsx(iconClass, 'text-purple-400')} />;
    case 'sms':
      return <MessageSquare className={clsx(iconClass, 'text-green-400')} />;
    case 'whatsapp':
      return <MessageCircle className={clsx(iconClass, 'text-green-400')} />;
    case 'live_chat':
      return <MessageSquare className={clsx(iconClass, 'text-cyan-400')} />;
    case 'messenger':
      return <MessageCircle className={clsx(iconClass, 'text-blue-400')} />;
    case 'instagram':
      return <Instagram className={clsx(iconClass, 'text-pink-400')} />;
    case 'video':
      return <Video className={clsx(iconClass, 'text-amber-400')} />;
    default:
      return <Globe className={clsx(iconClass, 'text-surface-400')} />;
  }
}
